import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

// Action types
const FETCH_TOKEN_INFO = 'FETCH_TOKEN_INFO';
const FETCH_TOKEN_INFO_COMPLETE = 'FETCH_TOKEN_INFO_COMPLETE';

const DEFAULT_STATE = {
  loading: true,
  scope: ''
};

// Reducer
export default function(state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_TOKEN_INFO:
      return DEFAULT_STATE;
    case FETCH_TOKEN_INFO_COMPLETE:
      return payload;
    default:
      return state;
  }
}

// Action creators
export const fetchTokenInfo = () => ({
  type: FETCH_TOKEN_INFO
});

export const fetchTokenInfoComplete = (token) => ({
  type: FETCH_TOKEN_INFO_COMPLETE,
  payload: token
});

// Epics
export const fetchTokenInfoEpic = (action$) => action$.pipe(
  ofType(FETCH_TOKEN_INFO),
  switchMap(() => JobProApi.tokenInfo()),
  map(fetchTokenInfoComplete)
);
